import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import {
  ARC_SMALL_LEFT,
  ARC_SMALL_RIGHT,
  SvgPathBuilder,
} from '../../../svg/SvgPathBuilder';
import { makeTag } from '../../../svg/utils';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createCircleNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawCircleBackground } from '../drawIconBackground';

const DIAMETER = 40;

const LOCK_BODY_TOP = -0.8;
const LOCK_BODY_BOTTOM = 8;
const LOCK_BODY_SIDE = 8;
const LOCK_SHANK_INNER_SIDE = 2.8;
const LOCK_SHANK_OUTER_SIDE = 5.6;
const LOCK_SHANK_ARC_BOTTOM = -4.4;

function createCloudVpnGwIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const lock = makeTag('path', {
    d: new SvgPathBuilder()
      // lock perimeter, drawn counter-clockwise
      .moveTo(-LOCK_BODY_SIDE, LOCK_BODY_TOP)
      .vLineTo(LOCK_BODY_BOTTOM)
      .hLineTo(LOCK_BODY_SIDE)
      .vLineTo(LOCK_BODY_TOP)
      .hLineTo(LOCK_SHANK_OUTER_SIDE)
      .vLineTo(LOCK_SHANK_ARC_BOTTOM)
      .circleTo(LOCK_SHANK_OUTER_SIDE, ARC_SMALL_RIGHT)(
        -LOCK_SHANK_OUTER_SIDE,
        LOCK_SHANK_ARC_BOTTOM,
      )
      .vLineTo(LOCK_BODY_TOP)
      .close()
      // hole in lock shank; had to be drawn in opposite direction (clockwise) to work
      .moveTo(LOCK_SHANK_INNER_SIDE, LOCK_BODY_TOP)
      .hLineTo(-LOCK_SHANK_INNER_SIDE)
      .vLineTo(LOCK_SHANK_ARC_BOTTOM)
      .circleTo(LOCK_SHANK_INNER_SIDE, ARC_SMALL_LEFT)(
        LOCK_SHANK_INNER_SIDE,
        LOCK_SHANK_ARC_BOTTOM,
      )
      .buildClosed(),
    fill: ICON_DEFAULT_FOREGROUND_COLOR,
  });

  const icon = `${drawCircleBackground(DIAMETER / 2, opts.style)}${lock}`;

  return wrapNodeIconInSvgTag(icon, DIAMETER, DIAMETER, 'center', opts);
}

export const cloudVpnGwIcon: NodeTypeIcon = createCircleNodeTypeIcon(
  DIAMETER,
  createCloudVpnGwIcon,
);
